<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <loader :loading="loadingAttributes || loadingCategories"/>

    <form-group :label="$t('warrantyTime.label')" :columns="3" :error="getError('warrantyTime', product.productId)" :required="true">
      <div class="form-flex">
        <input v-model="product.warrantyTime" class="form-input" :disabled="disabledInputs()" :required="true" type="number">
        <span class="form-addon">meses</span>
      </div>
    </form-group>

    <input v-model="product.brand" class="form-input" slot="brands" :disabled="disabledInputs()">

    <form-group :label="$t('department.label')" :columns="3" :error="getError('department', product.productId)" :required="true">
      <multiselect
        v-model="department"
        :options="departments"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        label="label"
        track-by="code"
      />
    </form-group>

    <form-group :label="$t('category.label')" :columns="3" :error="getError('category', product.productId)" v-if="categories.length" :required="true">
      <multiselect
        v-model="category"
        :options="categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        label="label"
        track-by="code"
      />
    </form-group>

    <div class="l-col-12@md" v-if="product.category">
      <div class="divider"><span>Atributos</span></div>
    </div>

    <form-group v-for="(attribute, index) in attributes" :key="attribute.id" :label="attribute.name" :columns="3" :error="getError(attribute.id, product.productId)" :required="attribute.required">
      <select v-model="attribute.value" class="form-select" :disabled="disabledInputs()" v-if="attribute.type === 'MVU'">
        <option value="undefined">{{ $t('choose.label') }}</option>
        <option v-for="option in attribute.values" :value="option.text">{{ option.text }}</option>
      </select>

      <multiselect v-model="attribute.value" label="text" track-by="id" :options="attribute.values" :multiple="true" v-else-if="attribute.type === 'MVM' && attribute.multiselect" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção"/>
      <input class="form-input" type="text" v-model="attribute.value" :disabled="disabledInputs()" v-else>
    </form-group>
  </shared-product-provide>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
import FormGroup from '@/components/template/FormGroup'
import api from '@/api'
import Multiselect from 'vue-multiselect'
import Loader from '@/components/template/Loader'
import notifier from '@/notifier'

export default {
  provide: {
    moduleDI: {
      type: 'marketplace',
      identifier: 'cnova'
    },
    maxDescriptionLengthDI: 18000,
    allowDescriptionHtml: true
  },
  data: () => ({
    loadingCategories: false,
    loadingAttributes: false,
    departments: [],
    categories: [],
    categoriesWithWarranty: [],
    attributes: [],
    department: null,
    category: null,
    categoryPreset: null
  }),
  props: {
    product: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    toModule: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('errors', [
      'getError'
    ])
  },
  mounted () {
    api.getCategories('marketplace', 'cnova')
      .then(departments => {
        this.departments = departments

        this.product.department = ''
        const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)
        if (presetCategorization !== null && presetCategorization !== undefined) {
          this.categoryPreset = presetCategorization.category

          this.department = this.departments.find(department => department.code === presetCategorization.department)
        }
      })
    this.$parent.loadingProducts(false)
  },
  methods: {
    ...mapActions('errors', [
      'addError',
      'clearErrors'
    ]),
    formatProduct () {
      this.clearErrors()

      if (this.product.department === undefined || this.product.department === '' || this.product.department === null) {
        this.addError({
          productId: this.product.productId,
          property: 'department',
          error: {
            message: 'required',
            value: 1
          }
        })
        this.$parent.validateRequiredAttributes()
      }

      if (this.product.category === undefined || this.product.category === '' || this.product.category === null) {
        this.addError({
          productId: this.product.productId,
          property: 'category',
          error: {
            message: 'required',
            value: 1
          }
        })
        this.$parent.validateRequiredAttributes()
      }

      this.attributes
        .map(attribute => {
          if (attribute.value === undefined && attribute.required) {
            this.addError({
              productId: this.product.productId,
              property: attribute.id,
              error: {
                message: 'required',
                value: 1
              }
            })
          }
        })

      this.product.variations
        .map(variation => {
          if (variation.ean === undefined || variation.ean === null || variation.ean === '') {
            this.addError({
              productId: variation.sku,
              property: 'ean',
              error: {
                message: 'required',
                value: 1
              }
            })
            return
          }

          if (variation.height < 1 || variation.height > 700) {
            this.addError({
              productId: variation.sku,
              property: `height`,
              error: {
                message: 'height',
                value: 1
              }
            })
            return
          }

          if (variation.width < 1 || variation.width > 700) {
            this.addError({
              productId: variation.sku,
              property: 'width',
              error: {
                message: 'width',
                value: 1
              }
            })
            return
          }

          if (variation.height < 1 || variation.width > 700) {
            this.addError({
              productId: variation.sku,
              property: 'width',
              error: {
                message: 'width',
                value: 1
              }
            })

            return
          }

          if (variation.length < 1 || variation.length > 700) {
            this.addError({
              productId: variation.sku,
              property: 'length',
              error: {
                message: 'length',
                value: 1
              }
            })

            return
          }
        })

      this.product.variations
        .map(variation => {
          variation.cnovaAttributes
            .map(attribute => {
              if (attribute.value === undefined && attribute.required) {
                this.addError({
                  productId: variation.sku,
                  sku: variation.sku,
                  property: attribute.id,
                  error: {
                    message: 'required',
                    value: 1
                  }
                })
              }
            })
        })

      const attributes = cloneDeep(this.attributes)
        .filter(attribute => attribute.value !== undefined && attribute.value !== 'undefined')
        .map(attribute => {
          if (attribute.multiselect) {
            attribute.value = attribute.value.map(value => value.text).join(',')
          }

          return {
            id: attribute.id,
            label: attribute.name,
            valueLabel: attribute.value,
            valueId: attribute.value
          }
        })

      return this.product.variations
        .filter(variation => variation.selected)
        .map(variation => {
          const variationAttributes = cloneDeep(variation.cnovaAttributes)
            .filter(attribute => attribute.value !== undefined && attribute.value !== 'undefined')
            .map(attribute => {
              if (attribute.multiselect) {
                attribute.value = attribute.value.map(value => value.text).join(',')
              }

              return {
                id: attribute.id,
                label: attribute.name,
                valueLabel: attribute.value,
                valueId: attribute.value
              }
            })

          return {
            attributes: attributes,
            brand: this.product.brand,
            crossDocking: {
              quantity: variation.crossDocking || 1
            },
            description: this.product.description,
            ean: variation.ean,
            height: variation.height,
            images: variation.images.length ? variation.images : null,
            length: variation.length,
            original: {
              product: this.product,
              variation: variation
            },
            price: variation.price,
            productId: this.product.productId,
            category: this.product.category,
            sku: variation.sku,
            source: this.fromModule,
            stock: variation.stock,
            title: this.product.title,
            weight: variation.weight,
            width: variation.width,
            warrantyTime: this.product.warrantyTime,
            variationAttributes: variationAttributes
          }
        }
      )
    },
    disabledInputs () {
      return this.product.status === 'sent' || this.product.status === 'error'
    },
    getCategories (categoryPreset) {
      this.loadingCategories = true
      this.product.category = ''

      if (!this.product.department) {
        this.clearAttributes()
        this.categories = []
        this.loadingCategories = false
        return false
      }

      api.getCategories('marketplace', 'cnova', this.product.department)
        .then(categories => {
          this.categories = categories

          if (categoryPreset !== null) {
            this.category = categories.find(category => category.code === categoryPreset)
            this.getAttributes()
          }

          this.loadingCategories = false
        })
        .catch(() => notifier.error('Erro ao buscar tipos de produtos da Cnova.', 'Erro'))
    },
    clearAttributes () {
      this.product.variations.forEach(variation => (this.$set(variation, 'cnovaAttributes', [])))
      this.attributes = []
    },
    getAttributes () {
      if (!this.product.category) {
        this.clearAttributes()
        return false
      }

      this.loadingAttributes = true

      const category = this.categories.find(category => this.product.category === category.code)

      const variationsAttributes = category.attributes.filter(attribute => attribute.variant)

      this.product.variations.forEach(variation => (this.$set(variation, 'cnovaAttributes', cloneDeep(variationsAttributes))))

      this.attributes = category.attributes.filter(attribute => (!attribute.variant && attribute.name !== 'Garantia'))

      this.loadingAttributes = false
    }
  },
  watch: {
    department (value) {
      this.product.department = value.code

      this.getCategories(this.categoryPreset)
    },
    category (value) {
      this.product.category = value.code

      this.getAttributes()
    }
  },
  components: {
    SharedProductProvide,
    FormGroup,
    Multiselect,
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// Product.vue?4eff0ec5